export const ABOUT_CONTENT_REQUEST = 'ABOUT_CONTENT_REQUEST';
export const ABOUT_CONTENT_SUCCESS = 'ABOUT_CONTENT_SUCCESS';
export const ABOUT_CONTENT_FAIL = 'ABOUT_CONTENT_FAIL';


export const SLIDE_CONTENT_REQUEST = 'SLIDE_CONTENT_REQUEST';
export const SLIDE_CONTENT_SUCCESS = 'SLIDE_CONTENT_SUCCESS';
export const SLIDE_CONTENT_FAIL = 'SLIDE_CONTENT_FAIL';
